import React from 'react';
import PageLayout from '../../layout/PageLayout';
import NmckSecurityServicesCalculation from '../../layout/NmckGroup/NmckSecurityServicesCalculation';

const NmckSecurityServicesCalculationPage: React.FC = () => (
  <PageLayout>
    <NmckSecurityServicesCalculation />
  </PageLayout>
);

export default NmckSecurityServicesCalculationPage;
